import { OutlineButtonNeutral } from 'rwl-ui';
import { ShareSVG } from '../../../themes/icons';
import { HideOnMDScreen } from '../HideOnMDScreen';
import { useTechnician } from '../../../hooks/useTechnician';
import createShare from '../../../fetchers/CreateShare/createShare';
import { useAPIRoute } from '../../../hooks/useAPIRoute';
import { useEnqueueEngagement, useGlobal } from '../../../hooks';
import { ConversionType } from 'rwl-shared/dist/models/plugin/Conversion';

type ShareViaBrowserProps = {
    accountName: string;
    mediaId?: string;
    workSiteId?: string;
};

export const ShareViaBrowser = ({
    accountName,
}: ShareViaBrowserProps): JSX.Element | null => {
    const sharePayload = {
        url: window.location.href,
        title: `Portfolio for ${accountName}`,
    };

    const { technician, isTechnicianReady } = useTechnician();
    const { accountId } = useGlobal();
    const url = useAPIRoute('share');
    const { enqueue } = useEnqueueEngagement();

    const onClickShareButton = async () => {
        try {
            enqueue({
                type: 'Conversion',
                conversionType: ConversionType.Share,
                target: 'Share Native CTA',
                clickedAt: new Date(),
                pageUrl: window.location.href,
            });
            sharePayload.url = await createShare(url, accountId, technician);
            await navigator.share(sharePayload);
        } catch (e) {
            console.error(`share failed`, e);
        }
    };

    if (!isTechnicianReady) {
        return null;
    }

    if (!navigator.canShare || !navigator.canShare(sharePayload)) {
        return null;
    }

    return (
        <OutlineButtonNeutral
            onClick={onClickShareButton}
            className={'browserShare'}
        >
            <ShareSVG />
            <HideOnMDScreen>Share</HideOnMDScreen>
        </OutlineButtonNeutral>
    );
};
